import React, { Component } from 'react'

class MenuEnd extends Component {
    constructor(props) {
        super(props);

        this.state = { }
    }

    render() {
        return (
            <div style={{ minHeight: 30 }}> </div>
        );
    }
}

export default MenuEnd


// WEBPACK FOOTER //
// ./src/components/Menu/MenuEnd.js